/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".callout_8212a800 .ms-Suggestions-itemButton{padding:0px;border:none}.callout_8212a800 .ms-Suggestions{min-width:300px}\n"}]);
export const callout = "callout_8212a800";